import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Heading,
  Text,
  Link,
  Icon,
} from "@chakra-ui/react";
import { InfoIcon } from "@chakra-ui/icons";
import styled from "styled-components";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #339cff 0%, #1a7fd4 100%);
  margin-bottom: 1.5rem;
`;

export const CampaignBuilderModal = ({ isOpen, onClose }: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Campaign Builder</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={6} align="center" textAlign="center" py={4}>
            <IconWrapper>
              <Icon as={InfoIcon} boxSize={10} color="white" />
            </IconWrapper>

            <Heading size="lg" color="#1A202C">
              Coming Soon
            </Heading>

            <Text fontSize="md" color="gray.600">
              The Campaign Builder is currently under development.
            </Text>

            <Text fontSize="sm" color="gray.500" lineHeight="tall">
              Please reach out to your rep or{" "}
              <Link
                href="mailto:hello@skipgive.com"
                color="#339CFF"
                fontWeight="600"
                _hover={{ textDecoration: "underline" }}
              >
                hello@skipgive.com
              </Link>{" "}
              to build a campaign.
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
